import PropTypes from 'prop-types';
import './DragDropOverlay.css';

const DragDropOverlay = ({ text, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="drag-drop-overlay">
      <div className="drag-drop-content">
        <i className="fa fa-arrow-circle-up drag-drop-icon" />
        <span className="drag-drop-text">{text}</span>
      </div>
    </div>
  );
};

DragDropOverlay.propTypes = {
  text: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export default DragDropOverlay;
